import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Typography from "@material-ui/core/Typography";
import { Button } from "../ui/button";

const styles = () => ({
  root: {
    padding: "16px 24px 8px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dialogTitle: {
    fontSize: "18px",
    fontWeight: "700",
    // color: "#1E293B", // slate-800
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" className={classes.dialogTitle}>
        {children}
      </Typography>
      {/* {onClose && (
        <X
          onClick={onClose}
          className="w-5 h-5 cursor-pointer text-slate-500 hover:text-slate-700"
        />
      )} */}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(() => ({
  root: {
    padding: "20px 24px",
  },
}))(MuiDialogContent);

const DialogActions = withStyles(() => ({
  root: {
    padding: "12px 24px 20px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "12px",
  },
}))(MuiDialogActions);

export default function DialogComponent(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSave = () => {
    props?.ModalActionsSave?.();
    setOpen(false);
  };

  const handleCancel = () => {
    props?.ModalActionsCancel?.();
    setOpen(false);
  };

  return (
    <div className={props?.buttonWrapClassName}>
      <Button
        variant="outline"
        onClick={handleClickOpen}
        className={`${props?.buttonClassName} themeButton`}
        {...props?.buttonProps}
      >
        {props.buttonLabel}
      </Button>

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        className="thameSecondaryDialog"
        fullWidth
        maxWidth="sm"
        {...props?.dialogProps}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
          modaltitlewrapclasses={props.modaltitlewrapclasses}
          className="dark:bg-[#1A1F2C] text-foreground"
        >
          {props?.ModalTitle}
        </DialogTitle>

        {props?.ModalDescription && (
          <div
            className="px-6 pb-2 text-slate-500 text-sm font-normal dark:bg-[#1A1F2C] dark:text-white"
          >
            {props.ModalDescription}
          </div>
        )}

        <DialogContent className="thameDialogContent dark:bg-[#1A1F2C] dark:text-white">
          {React.cloneElement(props.ModalContent, { onClose: handleClose })}
        </DialogContent>

        {(props.ModalActionsSave || props.ModalActionsCancel) && (
          <DialogActions>
            {props.ModalActionsCancel && (
              <Button
                variant="outline"
                onClick={handleCancel}
                className="rounded-md px-4 py-2 dark:bg-gray-800 dark:text-white"
              >
                {props.CancelLabel || "Cancel"}
              </Button>
            )}
            {props.ModalActionsSave && (
              <Button
                variant="contained"
                onClick={handleSave}
                className="bg-green text-white rounded-md px-4 py-2"
              >
                {props.SaveLabel || "Save"}
              </Button>
            )}
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}
